import React from 'react';
import { connect } from 'react-redux';
import { requestLocationChange } from '../actions';

import css from './viewercard.css';

// Material UI Library
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';
import { Card, CardText, CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import FlatButton from 'material-ui/FlatButton';

const listItemStyle = {
  padding: '8px 16px',
};

const AddressBlock = (props) => {
  if (props.address === undefined || props.address === null) return <div></div>;

  return (
    <List key={props.address.id}>
      <ListItem
        primaryText={props.address.street1}
        secondaryText="Street Address"
        innerDivStyle={listItemStyle}
      />
      <ListItem
        primaryText={props.address.street2}
        secondaryText="Street Address 2"
        innerDivStyle={listItemStyle}
      />
      <ListItem
        primaryText={`${props.address.city}, ${props.address.state}`}
        secondaryText="City/State"
        innerDivStyle={listItemStyle}
      />
      <ListItem
        primaryText={`${props.address.zip}, ${props.address.country}`}
        secondaryText="Zip/Country"
        innerDivStyle={listItemStyle}
      />
    </List>
  );
}



function CollectiveCard(props) {
  return (
    <Card>
      <div>
        <div className={css.headerContainer}>
          <Avatar
            src=""
            size={150}
            style={{ display: 'block', margin: 'auto' }}
          />
          <div className={css.headerText}>
            <h1 style={{ margin: '16px 0 0' }}>
              {props.collective.name}
            </h1>
            <p className={css.subHeader}>
              {props.collective.parentName}
            </p>
            <p className={css.subHeader}>
              {props.collective.type === 'NewMediaCollective' ? 'Collective' : 'Media Outlet' }
            </p>
          </div>
        </div>
          <div>
            <Toolbar>
              <ToolbarGroup>
                <ToolbarTitle text="Contact Information" />
              </ToolbarGroup>
              <ToolbarGroup>
                <FlatButton onClick={props.handleEditCollective.bind(this, props.collective.id)}>Edit</FlatButton>
              </ToolbarGroup>
            </Toolbar>
            {props.collective.contact &&
            <List>
              <ListItem
                primaryText={`${props.collective.contact.firstName} ${props.collective.contact.lastName}`}
                secondaryText="Primary Contact"
                innerDivStyle={listItemStyle}
              />
              <ListItem
                primaryText={props.collective.contact.email || 'N/A'}
                secondaryText="Email"
                innerDivStyle={listItemStyle}
              />
            </List>
            }
          </div>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text="Influencers" />
          </ToolbarGroup>
        </Toolbar>
        <List>
          {props.collective.influencers.map(influencer =>
            <ListItem
              key={influencer.id}
              primaryText={`${influencer.firstName} ${influencer.lastName}`}
              secondaryText={influencer.alias ? `(${influencer.alias})` : ''}
              onTouchTap={props.handleViewInfluencerDetails.bind(this, props.collective.id, influencer.id)}
            />
          )}
        </List>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text="Primary Address" />
          </ToolbarGroup>
        </Toolbar>
        <AddressBlock address={props.collective.address}/>

        {props.collective.addresses && props.collective.addresses.length &&
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text="Other Addresses" />
            </ToolbarGroup>
          </Toolbar>
        }
        <List>
            {props.collective.addresses.filter(address => {
              if (!props.collective.address) return true;
              return address.street1.length && address.id !== props.collective.address.id;
            }).map((address, index) =>
              <AddressBlock address={address}/>
            )}
          <ListItem
            primaryText={
              props.collective.collectiveMediaPlatforms.map(platform =>
                <p key={platform.id}>{platform.name}</p>
              )
            }
            secondaryText="Platforms"
            innerDivStyle={listItemStyle}
          />
        </List>
      </div>
    </Card>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    handleViewInfluencerDetails: function (collectiveId, influencerId) {
      dispatch(requestLocationChange('collectiveViewInfluencer',
        { collectiveId: collectiveId, id: influencerId })
      );
    },

    handleEditCollective: function (id) {
      dispatch(requestLocationChange('editCollective', { id: id }));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectiveCard);



/** WEBPACK FOOTER **
 ** ./components/CollectiveCard.js
 **/